import User from '../models/UserModel';
import { types } from "mobx-state-tree";
import { getUser, getKidUserObjects, setChildOptionsVisible as setChildOptionsVisibleApi } from '../api_calls/user';
import FamilyStore from "./FamilyStore";
import { sha512 } from 'hash-anything';
import AuthStore from "./AuthStore";
import { message } from "utils/ui";
import _ from "underscore";
import { appColours } from '../utils/styles/colours';
import { createLog, sessionEnd } from '../api_calls/logging';

const KidModel = types.model('KidModel', {
    jwt: types.optional(types.string, ""),
    name: types.optional(types.string, ""),
    id: types.optional(types.string, "")
})
const LS_KEY = 'mm-login-demo:auth';
const UserStoreModel = types
    .model('UserStore', {
        loading: types.boolean,
        loaded: types.boolean,
        profileImage: types.optional(types.string, "img/default-user.png"),
        user: User,
        activeChild: types.optional(KidModel, {}),
        childViewActive: types.optional(types.boolean, false),
        childView: types.optional(types.string, ""),
        children: types.optional(types.array(User), []),
        inviteUrl: types.optional(types.string, ""),
        // handleLoggedIn: types.optional(types.reference(""), ""),
        defaultImage: "img/default-user.png"
    })
    .views(self => {
        return {
            isLoaded: () => self.loaded,
            isLoading: () => self.loading,
            getUser: (uId) => _.findWhere(FamilyStore.family.concat([self.user]), {_id: uId}),
            can: (action, groupId) => {
                const activeGroup = FamilyStore.activeGroup;
                if (activeGroup) {
                    if (activeGroup.creator === self.user._id) {
                        return true;
                    }
                    const groupRoles = activeGroup.roles;
                    return groupRoles.get(self.user._id) ? groupRoles.get(self.user._id).roles.includes(action) : false;

                }
                return false;
            },
            theme: () => {return appColours(self.user.settings.theme)}
        }
    })
    .actions(self => {
        return {
            handleLoggedIn: (auth, inviteId = null) => {
                localStorage.setItem(LS_KEY, JSON.stringify(auth));
                AuthStore.authUser(auth);
                return getUser(auth.accessToken).then((user) => {
                    self.setUser(user, null, auth.accessToken, inviteId);
                    return user;
                });
            },
            setChildren: (children) => {
                self.children = children;
            },
            setUser: async (user, groupToUse = null, token = null, inviteId = "") => {
                if (user) {
                    self.user = user;
                    self.setProfileImage(user.profileImage);
                    FamilyStore.setActiveGroup(user.groups.length > 0 ? (groupToUse || user.groups[0].id) : inviteId);
                    let logObj = {
                        type: "logIn",
                        userId: user._id
                    };
                    if (FamilyStore.activeGroupId) {
                        logObj.groupId = FamilyStore.activeGroupId;
                    }
                    if (token && logObj.userId) {
                        createLog(token, logObj);
                    }
                    
                    if (user.kids && user.kids.length) {
                        getKidUserObjects(AuthStore.userAuth.auth.accessToken).then((objects) => {
                            self.setChildren(objects);
                        });
                    }
                }
            },
            setChildViewActive: (isActive) => {
                self.childViewActive = isActive;
                if (isActive) {
                    self.changeProfileImgForChildView(_.findWhere(FamilyStore.family, { _id: self.childView }) ? _.findWhere(FamilyStore.family, { _id: self.childView }).profileImage : self.defaultImage);
                } else {
                    self.changeProfileImgForChildView(self.profileImage);
                }
            },
            setActiveChild: async (activeChild) => {
                let email = activeChild.email;
                let passHash = sha512(activeChild.name);

                fetch(`${process.env.REACT_APP_BACKEND_URL}/auth`, {
                    body: JSON.stringify({ email, passHash }),
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    method: 'POST'
                }).then((response) => {

                    if (response.status === 401 || response.status === 403) {
                        return message.error("Email or password does not match database!");
                    } else {
                        return response.json().then(res => self.setActiveChildObject(res, activeChild))
                    }
                })

            },
            setActiveChildObject: (res, activeChild) => {
                let obj = {
                    id: activeChild._id,
                    name: activeChild.name,
                    jwt: res.accessToken
                }
                self.activeChild = obj;
            },
            setChildView: (childId) => {
                self.childView = childId;
            },
            setInviteUrl: (url) => {
                self.inviteUrl = url;
            },
            setLoading: (loading) => {
                self.loading = loading;
            },
            setLoaded: (loaded) => {
                self.loaded = loaded;
            },
            setChildOptionsVisible: (isVisible) => {
                self.user.childOptionsVisible = isVisible;
                setChildOptionsVisibleApi(self.user._id, isVisible, AuthStore.userAuth.auth.accessToken);
            },
            changeProfileImgForChildView: (img) => {
                self.setLoading(true);
                self.setLoaded(false);
                setTimeout(() => {
                    var imgtag = document.getElementsByClassName("profile-img");
                    for (let item of imgtag) {
                        if (img) {
                            item.src = img;
                        }
                    }
                }, 50);
                self.setLoading(false);
                self.setLoaded(true);
            },
            setProfileImage: (imageFile) => {
                self.setLoading(true);
                self.setLoaded(false);
                self.profileImage = imageFile;
                if (!self.childViewActive) {
                    setTimeout(() => {
                        var imgtag = document.getElementsByClassName("profile-img");
                        for (let item of imgtag) {
                            if (imageFile) {
                                item.src = imageFile;
                            }
                        }
                        var settingsImg = document.getElementsByClassName("profile-img-settings");
                        if (imageFile) {
                            settingsImg.src = imageFile;
                        }
                    }, 50);
                }
                self.setLoading(false);
                self.setLoaded(true);
            },
            refreshUser: async (auth, groupId = null) => {
                getUser(auth).then((userFound) => {
                    if (userFound){
                        self.setUser(userFound, groupId);
                    }
                    //self.setProfileImage(userFound.profileImage);
                })

            },
            refreshGroups: async (groupToUse = null) => {
                self.refreshUser(AuthStore.userAuth.auth.accessToken, groupToUse);


            }

        }
    });


const UserStore = UserStoreModel.create({
    loading: false,
    loaded: false,
    user: {
        _id: "guest",
        name: "guest",
        role: "guest",
        childViewActive: false,
        profileImage: "img/default-user.png",

    }
});

export default UserStore;




